(function () {
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function isToggle(sym){ sym=(sym||'').trim(); return sym==='+'||sym==='−'||sym==='-'; }

  ready(function () {
    /* ---- FAQ accordion ---- */
    [].slice.call(document.querySelectorAll('.psy-faq-q')).forEach(function (btn, i) {
      var panel = btn.nextElementSibling;
      var ind = btn.querySelector('.psy-faq-ind');
      if (!panel) return;
      function set(open) { panel.style.display = open ? '' : 'none'; if (ind) ind.textContent = open ? '−' : '+'; }
      set(i === 0);                                   // first open, rest closed
      btn.addEventListener('click', function () { set(panel.style.display === 'none'); });
    });

    /* ---- Gallery: active thumbnail (red border + bright), carousel arrows ---- */
    var gstrip = document.querySelector('.psy-gal-strip');
    if (gstrip) {
      var gthumbs = [].slice.call(gstrip.querySelectorAll('.psy-gal-thumb'));
      var gmain = document.querySelector('.psy-gal-main-img');
      var gcap = document.querySelector('.psy-gal-cap');
      var gcount = document.querySelector('.psy-gal-counter');
      var gtotal = gthumbs.length, gcur = 0;
      function gactivate(idx, skipScroll) {
        if (!gtotal) return;
        idx = (idx + gtotal) % gtotal; gcur = idx;
        gthumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
        var t = gthumbs[idx];
        var src = t.getAttribute('data-src'), cap = t.getAttribute('data-cap') || '';
        if (gmain && src) { gmain.src = src; gmain.alt = cap; }
        if (gcap) gcap.textContent = cap;
        if (gcount) gcount.textContent = ('0' + (idx + 1)).slice(-2) + ' / ' + ('0' + gtotal).slice(-2) + (cap ? ' · ' + cap : '');
        /* only centre the thumb in its strip on user interaction; on initial load this would drag the whole page down to the gallery */
        if (!skipScroll) { try { t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); } catch (e) {} }
      }
      gthumbs.forEach(function (t, k) { t.addEventListener('click', function () { gactivate(k); }); });
      var gprev = document.querySelector('.psy-gal-prev'), gnext = document.querySelector('.psy-gal-next');
      if (gprev) gprev.addEventListener('click', function () { gactivate(gcur - 1); });
      if (gnext) gnext.addEventListener('click', function () { gactivate(gcur + 1); });
      gactivate(0, true);
    }

    /* ---- Walkthrough video: lightbox on desktop, inline on mobile ---- */
    var lb = document.querySelector('.psy-lightbox');
    function closeLb() {
      if (!lb) return;
      var lv = lb.querySelector('video');
      lv.pause(); lv.removeAttribute('src'); lv.load();
      lb.hidden = true; document.body.style.overflow = '';
    }
    document.querySelectorAll('.psy-video').forEach(function (box) {
      var src = box.getAttribute('data-video');
      box.addEventListener('click', function (e) {
        if (!src) return;
        e.preventDefault();
        if (window.innerWidth >= 768 && lb) {
          var lv = lb.querySelector('video');
          lv.src = src; lb.hidden = false; document.body.style.overflow = 'hidden';
          var p = lv.play(); if (p && p.catch) p.catch(function () {});
        } else {
          if (box.querySelector('video.psy-inline')) return;
          var iv = document.createElement('video');
          iv.className = 'psy-inline'; iv.src = src;
          iv.controls = true; iv.autoplay = true; iv.setAttribute('playsinline', '');
          iv.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;background:#000;z-index:2;';
          box.appendChild(iv);
          var ov = box.querySelector('.psy-video-overlay'); if (ov) ov.style.display = 'none';
          var po = box.querySelector('.psy-video-poster'); if (po) po.style.display = 'none';
          var pp = iv.play(); if (pp && pp.catch) pp.catch(function () {});
        }
      });
    });
    if (lb) {
      lb.querySelector('.psy-lightbox-close').addEventListener('click', closeLb);
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) closeLb(); });
    }

    /* ---- Reviews carousel ---- */
    var rv = document.querySelector('.psy-rv');
    if (rv) {
      var rdata = [].slice.call(rv.querySelectorAll('.psy-rv-data > div')).map(function (n) {
        return { quote: n.getAttribute('data-quote'), name: n.getAttribute('data-name'), loc: n.getAttribute('data-loc'), img: n.getAttribute('data-img') };
      });
      if (rdata.length) {
        var rimg = rv.querySelector('.psy-rv-img'), rq = rv.querySelector('.psy-rv-quote'),
            rnm = rv.querySelector('.psy-rv-name'), rlc = rv.querySelector('.psy-rv-loc'),
            rct = rv.querySelector('.psy-rv-counter'), rnav = rv.querySelector('.psy-rv-nav');
        var rcur = 0, rtot = rdata.length;
        function rshow(i) {
          i = (i + rtot) % rtot; rcur = i; var d = rdata[i];
          if (rimg && d.img) { rimg.src = d.img; rimg.alt = d.name || ''; }
          if (rq) rq.textContent = d.quote || '';
          if (rnm) rnm.textContent = d.name || '';
          if (rlc) rlc.textContent = d.loc || '';
          if (rct) rct.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + rtot).slice(-2);
        }
        if (rtot <= 1 && rnav) rnav.style.display = 'none';
        var rp = rv.querySelector('.psy-rv-prev'), rn = rv.querySelector('.psy-rv-next');
        if (rp) rp.addEventListener('click', function () { rshow(rcur - 1); });
        if (rn) rn.addEventListener('click', function () { rshow(rcur + 1); });
        rshow(0);
      }
    }

    /* ---- Tally loader ---- */
    var d = document, w = "https://tally.so/widgets/embed.js";
    var v = function () {
      if (typeof Tally !== 'undefined') { Tally.loadEmbeds(); return; }
      d.querySelectorAll('iframe[data-tally-src]:not([src])').forEach(function (e) { e.src = e.dataset.tallySrc; });
    };
    if (typeof Tally !== 'undefined') v();
    else if (!d.querySelector('script[src="' + w + '"]')) {
      var s = d.createElement('script'); s.src = w; s.onload = v; s.onerror = v; d.body.appendChild(s);
    }
  });
})();
